// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
}
.menu-selection {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  width: 100%;
  height: 200px;
}

.menu-selection h1 {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 200px;
  font-family: Kanit;
  font-weight: bold;
  font-size: 50px;
  color: #0077b6;
}

.menu-selection .form-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 100px;
  padding-right: 100px;
}

.menu-selection .toggleContainer {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  border: 3px solid #343434;
  border-radius: 10px;
  background: #ffffff;
  font-weight: bold;
  color: #343434;
  cursor: pointer;
}

.menu-selection .toggleContainer::before {
  content: "";
  position: absolute;
  width: 50%;
  height: 100%;
  left: 0%;
  border-radius: 1px;
  background-image: linear-gradient(
    92.88deg,
    #023e8a 0%,
    #0077b6 100%,
    #0165a8 100%
  );
  transition: all 0.3s;
}
.menu-selection .toggleCheckbox:checked + .toggleContainer::before {
  left: 50%;
}
.menu-selection .toggleContainer div {
  padding: 6px;
  text-align: center;
  z-index: 1;
}
.menu-selection .toggleCheckbox {
  display: none;
}
.menu-selection .toggleCheckbox:checked + .toggleContainer div:first-child {
  color: black;
  transition: color 0.3s;
}
.menu-selection .toggleCheckbox:checked + .toggleContainer div:last-child {
  color: #ffffff;
  transition: color 0.3s;
}
.menu-selection .toggleCheckbox + .toggleContainer div:first-child {
  color: white;
  transition: color 0.3s;
}
.menu-selection .toggleCheckbox + .toggleContainer div:last-child {
  color: black;
  transition: color 0.3s;
}

.menu-selection button {
  display: block;
  margin-top: auto;
  margin-bottom: auto;
  width: 150px;
  height: 40px;
  border-radius: 10px;
  color: green;
  background-color: white;
  font-family: Kanit;
  font-weight: bold;
  font-size: 20px;
}

.menu-selection button:hover {
  background-color: rgb(160, 235, 185);
}

.investigate-button:hover {
  color: rgb(156, 109, 0);
}

.table-container {
  margin-left: auto;
  margin-right: auto;
  /* display: flex; */
  width: 80%;
  height: 575px;
  background-color: rgb(255, 255, 255);
  filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0));
  border-radius: 10px;
}

.menu-search-bar {
  width: 90%;
  height: 75px;
  position: absolute;
  background-image: linear-gradient(90deg, #61028a 0%, #5d00c7 100%);
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: -35px;
  border-radius: 10px;
  text-align: center;
  z-index: 2;
}

.menu-search-bar .header {
  font-family: Kanit;
  text-align: center;
  justify-content: center;
  margin-top: 10px;
  color: white;
}

.menu-search-bar .search-border {
  height: 40px;
  width: 300px;
  position: absolute;
  top: 15px;
  right: 30px;
  display: flex;
}

.menu-search-bar .search-border h3 {
  font-weight: 400;
  padding-right: 10px;
  color: white;
}

.menu-search-bar input {
  width: 80%;
  height: 100%;
  justify-items: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  background-image: linear-gradient(97.41deg, #000000, #000000);
  border-color: white;
  color: white;
  border: 5px solid black;
  border-radius: 5px;
  font-size: 25px;
  padding-left: 5px;
  padding-bottom: 2.5px;
  font-family: Kanit;
}

.table-space {
  width: 250px;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: Kanit;
  font-size: 22px;
  border-bottom-width: 1px;
}
.page-changer-container {
  display: flex;

  justify-content: right;
  margin-right: 200px;
  margin-top: 15px;
}

.page-changer-container button {
  width: 50px;
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px;
  background-image: linear-gradient(97.41deg, #023e8a, #0096c7);
  font-family: Kanit;
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.page-changer-container button:hover {
  background-image: linear-gradient(97.41deg, #ff792b, #a50104);
}

.modal-button-approve {
  height: 50px;
  width: 30%;

  display: block;
  margin: auto;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(2, 85, 0, 1) 20%,
    rgba(86, 131, 93, 1) 50%,
    rgba(2, 85, 0, 1) 80%,
    rgba(0, 0, 0, 1) 100%
  );
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.modal-button-approve:hover {
  transition-duration: 1s;

  background-image: linear-gradient(
    90deg,
    rgba(20, 167, 0, 1) 0%,
    rgba(11, 205, 0, 1) 50%,
    rgba(20, 167, 0, 1) 100%
  );
  color: green;
}

.modal-button-already-approve {
  height: 50px;
  width: 30%;

  display: block;
  margin: auto;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    rgba(20, 167, 0, 1) 0%,
    rgba(11, 205, 0, 1) 50%,
    rgba(20, 167, 0, 1) 100%
  );
  font-weight: bold;
  font-size: 20px;
  color: green;
}

.modal-button-standby {
  height: 50px;
  width: 30%;

  display: block;
  margin: auto;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(205, 113, 0, 1) 20%,
    rgba(161, 99, 0, 1) 50%,
    rgba(205, 113, 0, 1) 80%,
    rgba(0, 0, 0, 1) 100%
  );
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.modal-button-standby:hover {
  transition-duration: 1s;

  background-image: linear-gradient(
    90deg,
    rgba(161, 99, 0, 1) 0%,
    rgb(242, 210, 0) 50%,
    rgba(161, 99, 0, 1) 100%
  );
  color: rgb(199, 130, 0);
}

.modal-button-already-standby {
  height: 50px;
  width: 30%;

  display: block;
  margin: auto;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    rgba(161, 99, 0, 1) 0%,
    rgb(242, 210, 0) 50%,
    rgba(161, 99, 0, 1) 100%
  );
  font-weight: bold;
  font-size: 20px;
  color: rgb(199, 130, 0);
}

.modal-button-unapprove {
  height: 50px;
  width: 30%;

  display: block;
  margin: auto;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(154, 0, 0, 1) 20%,
    rgba(150, 7, 7, 1) 50%,
    rgba(154, 0, 0, 1) 80%,
    rgba(0, 0, 0, 1) 100%
  );
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.modal-button-unapprove:hover {
  transition-duration: 1s;

  background-image: linear-gradient(
    90deg,
    rgba(154, 0, 0, 1) 20%,
    rgb(255, 0, 0) 50%,
    rgba(154, 0, 0, 1) 80%
  );
  color: rgb(110, 0, 0);
}

.modal-button-already-unapprove {
  height: 50px;
  width: 30%;

  display: block;
  margin: auto;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    rgba(154, 0, 0, 1) 20%,
    rgb(255, 0, 0) 50%,
    rgba(154, 0, 0, 1) 80%
  );
  font-weight: bold;
  font-size: 20px;
  color: rgb(110, 0, 0);
}

.modal-button-confirm {
  height: 50px;
  width: 30%;

  display: block;
  margin: auto;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    rgb(0, 13, 97) 0%,
    rgb(0, 82, 149) 50%,
    rgba(0, 13, 97) 100%
  );
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.modal-button-confirm:hover {
  transition-duration: 1s;

  background-image: linear-gradient(
    90deg,
    rgb(0, 150, 225) 0%,
    rgb(0, 238, 255) 50%,
    rgba(0, 150, 225) 100%
  );
  color: rgb(2, 69, 176);
}

.modal-button-cancel {
  height: 50px;
  width: 30%;

  display: block;
  margin: auto;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    rgba(154, 0, 0, 1) 0%,
    rgb(129, 0, 0) 50%,
    rgba(154, 0, 0, 1) 100%
  );
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.modal-button-cancel:hover {
  transition-duration: 1s;

  background-image: linear-gradient(
    90deg,
    rgb(255, 153, 0) 0%,
    rgb(255, 0, 0) 50%,
    rgba(255, 153, 0) 100%
  );
  color: rgb(110, 0, 0);
}

@media screen and (max-width: 1400px) {
  .menu-selection {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    width: 100%;
    height: 200px;
  }

  .menu-selection h1 {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 70px;
    font-family: Kanit;
    font-weight: bold;
    font-size: 30px;
    color: #0077b6;
  }

  .menu-selection .form-toggle {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
  }

  .menu-selection .toggleContainer {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    border: 3px solid #343434;
    border-radius: 10px;
    background: #ffffff;
    font-weight: bold;
    font-size: 15px;
    color: #343434;
    cursor: pointer;
  }

  .menu-selection .toggleContainer::before {
    content: "";
    position: absolute;
    width: 50%;
    height: 100%;
    left: 0%;
    border-radius: 1px;
    background-image: linear-gradient(
      92.88deg,
      #023e8a 0%,
      #0077b6 100%,
      #0165a8 100%
    );
    transition: all 0.3s;
  }
  .menu-selection button {
    display: block;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 10px;
    width: 100px;
    height: 70px;
    border-radius: 10px;
    color: green;
    background-color: white;
    font-family: Kanit;
    font-weight: bold;
    font-size: 20px;
  }

  .table-container {
    margin-left: auto;
    margin-right: auto;

    width: 90%;
    height: 575px;
    background-color: rgb(255, 255, 255);
    filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0));
    border-radius: 10px;
  }

  .menu-search-bar {
    width: 90%;
    height: 100px;
    position: absolute;
    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: -35px;
    border-radius: 10px;
    text-align: center;
    z-index: 2;
  }

  .menu-search-bar .header {
    font-family: Kanit;
    text-align: center;
    justify-content: center;
    margin-top: -5px;
    color: white;
    font-size: 25px;
  }

  .menu-search-bar .search-border {
    height: 40px;
    width: 90%;
    position: absolute;
    top: 15px;
    right: 50px;
    display: flex;
  }

  .menu-search-bar .search-border h3 {
    font-weight: 400;
    margin-top: 35px;
    color: white;
  }

  .menu-search-bar input {
    width: 100%;
    height: 100%;
    justify-items: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 35px;
    background-image: linear-gradient(97.41deg, #000000, #000000);
    border-color: white;
  color: white;
  border: 5px solid black;
  border-radius: 5px;
    font-size: 25px;
    padding-left: 20px;
    padding-bottom: 2.5px;
    font-family: Kanit;
  }

  .table-space {
    width: 250px;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
    font-family: Kanit;
    font-size: 20px;
    border-bottom-width: 1px;
  }
  .page-changer-container {
    display: flex;

    justify-content: right;
    margin-right: 20px;
    margin-top: 15px;
  }

  .page-changer-container button {
    width: 40px;
    height: 40px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 10px;
    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);
    font-family: Kanit;
    color: white;
    font-size: 15px;
    font-weight: bold;
  }
}
@media screen and (max-width: 1000px) {
  .menu-selection {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    width: 100%;
    height: 200px;
  }

  .menu-selection h1 {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 70px;
    font-family: Kanit;
    font-weight: bold;
    font-size: 30px;
    color: #0077b6;
  }

  .menu-selection .form-toggle {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
  }

  .menu-selection .toggleContainer {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    border: 3px solid #343434;
    border-radius: 10px;
    background: #ffffff;
    font-weight: bold;
    font-size: 15px;
    color: #343434;
    cursor: pointer;
  }

  .menu-selection .toggleContainer::before {
    content: "";
    position: absolute;
    width: 50%;
    height: 100%;
    left: 0%;
    border-radius: 1px;
    background-image: linear-gradient(
      92.88deg,
      #023e8a 0%,
      #0077b6 100%,
      #0165a8 100%
    );
    transition: all 0.3s;
  }
  .menu-selection button {
    display: block;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 10px;
    width: 100px;
    height: 70px;
    border-radius: 10px;
    color: green;
    background-color: white;
    font-family: Kanit;
    font-weight: bold;
    font-size: 20px;
  }

  .table-container {
    margin-left: auto;
    margin-right: auto;

    width: 90%;
    height: 750px;
    background-color: rgb(255, 255, 255);
    filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0));
    border-radius: 10px;
    margin-bottom: 10px;
  }

  .menu-search-bar {
    width: 90%;
    height: 100px;
    position: absolute;
    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: -35px;
    border-radius: 10px;
    text-align: center;
    z-index: 2;
  }

  .menu-search-bar .header {
    font-family: Kanit;
    text-align: center;
    justify-content: center;
    margin-top: -5px;
    color: white;
    font-size: 25px;
  }

  .menu-search-bar .search-border {
    height: 40px;
    width: 90%;
    position: absolute;
    top: 15px;
    right: 50px;
    display: flex;
  }

  .menu-search-bar .search-border h3 {
    font-weight: 400;
    margin-top: 35px;
    color: white;
  }

  .menu-search-bar input {
    width: 100%;
    height: 100%;
    justify-items: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 35px;
    background-image: linear-gradient(97.41deg, #000000, #000000);
    border-color: white;
  color: white;
  border: 5px solid black;
  border-radius: 5px;
    font-size: 25px;
    padding-left: 20px;
    padding-bottom: 2.5px;
    font-family: Kanit;
  }

  .table-space {
    width: 250px;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
    font-family: Kanit;
    font-size: 20px;
    border-bottom-width: 1px;
  }
  .page-changer-container {
    display: flex;

    justify-content: right;
    margin-right: 20px;
    margin-top: 175px;
    margin-bottom: 10px;
  }

  .page-changer-container button {
    width: 40px;
    height: 40px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 10px;
    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);
    font-family: Kanit;
    color: white;
    font-size: 15px;
    font-weight: bold;
  }
}
@media screen and (max-width: 650px) {
  .menu-selection {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    width: 100%;
    height: 200px;
  }

  .menu-selection h1 {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 20px;
    font-family: Kanit;
    font-weight: bold;
    font-size: 30px;
    color: #0077b6;
  }

  .menu-selection .form-toggle {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
  }

  .menu-selection .toggleContainer {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    border: 3px solid #343434;
    border-radius: 10px;
    background: #ffffff;
    font-weight: bold;
    font-size: 10px;
    color: #343434;
    cursor: pointer;
  }

  .menu-selection .toggleContainer::before {
    content: "";
    position: absolute;
    width: 50%;
    height: 100%;
    left: 0%;
    border-radius: 1px;
    background-image: linear-gradient(
      92.88deg,
      #023e8a 0%,
      #0077b6 100%,
      #0165a8 100%
    );
    transition: all 0.3s;
  }
  .menu-selection button {
    display: block;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 10px;
    width: 100px;
    height: 70px;
    border-radius: 10px;
    color: green;
    background-color: white;
    font-family: Kanit;
    font-weight: bold;
    font-size: 20px;
  }

  .table-container {
    margin-left: auto;
    margin-right: auto;

    width: 90%;
    height: 575px;
    background-color: rgb(255, 255, 255);
    filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0));
    border-radius: 10px;
    margin-bottom: 10px;
  }

  .menu-search-bar {
    width: 90%;
    height: 100px;
    position: absolute;
    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: -35px;
    border-radius: 10px;
    text-align: center;
    z-index: 2;
  }

  .menu-search-bar .header {
    font-family: Kanit;
    text-align: center;
    justify-content: center;
    margin-top: -5px;
    color: white;
    font-size: 22px;
  }

  .menu-search-bar .search-border {
    height: 40px;
    width: 80%;
    position: absolute;
    top: 15px;
    display: flex;
  }

  .menu-search-bar .search-border h3 {
    font-weight: 400;
    display: none;
    color: white;
  }

  .menu-search-bar input {
    width: 100%;
    height: 100%;
    justify-items: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 35px;
    background-image: linear-gradient(97.41deg, #000000, #000000);
    border-color: white;
    border-color: white;
    color: white;
    border: 5px solid black;
    border-radius: 5px;
    padding-left: 5px;
    padding-bottom: 2.5px;
    font-family: Kanit;
  }

  .table-space {
    width: 250px;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
    font-family: Kanit;
    font-size: 5px;
    border-bottom-width: 1px;
  }
  .page-changer-container {
    display: flex;

    justify-content: right;
    margin-right: 20px;
    margin-bottom: 30px;
  }

  .page-changer-container button {
    width: 40px;
    height: 40px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 10px;
    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);
    font-family: Kanit;
    color: white;
    font-size: 15px;
    font-weight: bold;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/user/operation/SearchableTable.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB;;;;;GAKC;EACD,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,kEAAkE;EAClE,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,aAAa;;EAEb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;;;GAOC;EACD,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;;EAEvB;;;;;GAKC;EACD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;GAKC;EACD,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;;;GAOC;EACD,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;;EAEvB;;;;;GAKC;EACD,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;GAKC;EACD,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;;;GAOC;EACD,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;;EAEvB;;;;;GAKC;EACD,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;GAKC;EACD,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;GAKC;EACD,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;;EAEvB;;;;;GAKC;EACD,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;GAKC;EACD,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;;EAEvB;;;;;GAKC;EACD,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB;;;;;KAKC;IACD,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB,UAAU;IACV,aAAa;IACb,oCAAoC;IACpC,6CAA6C;IAC7C,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,6DAA6D;IAC7D,mBAAmB;EACrB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;IAChB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,aAAa;;IAEb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,6DAA6D;IAC7D,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB;;;;;KAKC;IACD,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB,UAAU;IACV,aAAa;IACb,oCAAoC;IACpC,6CAA6C;IAC7C,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,6DAA6D;IAC7D,mBAAmB;EACrB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;IAChB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,aAAa;;IAEb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,6DAA6D;IAC7D,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB;;;;;KAKC;IACD,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;;IAElB,UAAU;IACV,aAAa;IACb,oCAAoC;IACpC,6CAA6C;IAC7C,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,6DAA6D;IAC7D,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,wBAAwB;EAC1B;EACA;IACE,aAAa;;IAEb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,6DAA6D;IAC7D,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["body {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.menu-selection {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 200px;\r\n}\r\n\r\n.menu-selection h1 {\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  margin-left: 200px;\r\n  font-family: Kanit;\r\n  font-weight: bold;\r\n  font-size: 50px;\r\n  color: #0077b6;\r\n}\r\n\r\n.menu-selection .form-toggle {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding-left: 100px;\r\n  padding-right: 100px;\r\n}\r\n\r\n.menu-selection .toggleContainer {\r\n  position: relative;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  width: 100%;\r\n  border: 3px solid #343434;\r\n  border-radius: 10px;\r\n  background: #ffffff;\r\n  font-weight: bold;\r\n  color: #343434;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-selection .toggleContainer::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 50%;\r\n  height: 100%;\r\n  left: 0%;\r\n  border-radius: 1px;\r\n  background-image: linear-gradient(\r\n    92.88deg,\r\n    #023e8a 0%,\r\n    #0077b6 100%,\r\n    #0165a8 100%\r\n  );\r\n  transition: all 0.3s;\r\n}\r\n.menu-selection .toggleCheckbox:checked + .toggleContainer::before {\r\n  left: 50%;\r\n}\r\n.menu-selection .toggleContainer div {\r\n  padding: 6px;\r\n  text-align: center;\r\n  z-index: 1;\r\n}\r\n.menu-selection .toggleCheckbox {\r\n  display: none;\r\n}\r\n.menu-selection .toggleCheckbox:checked + .toggleContainer div:first-child {\r\n  color: black;\r\n  transition: color 0.3s;\r\n}\r\n.menu-selection .toggleCheckbox:checked + .toggleContainer div:last-child {\r\n  color: #ffffff;\r\n  transition: color 0.3s;\r\n}\r\n.menu-selection .toggleCheckbox + .toggleContainer div:first-child {\r\n  color: white;\r\n  transition: color 0.3s;\r\n}\r\n.menu-selection .toggleCheckbox + .toggleContainer div:last-child {\r\n  color: black;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.menu-selection button {\r\n  display: block;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  width: 150px;\r\n  height: 40px;\r\n  border-radius: 10px;\r\n  color: green;\r\n  background-color: white;\r\n  font-family: Kanit;\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n}\r\n\r\n.menu-selection button:hover {\r\n  background-color: rgb(160, 235, 185);\r\n}\r\n\r\n.investigate-button:hover {\r\n  color: rgb(156, 109, 0);\r\n}\r\n\r\n.table-container {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  /* display: flex; */\r\n  width: 80%;\r\n  height: 575px;\r\n  background-color: rgb(255, 255, 255);\r\n  filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0));\r\n  border-radius: 10px;\r\n}\r\n\r\n.menu-search-bar {\r\n  width: 90%;\r\n  height: 75px;\r\n  position: absolute;\r\n  background-image: linear-gradient(90deg, #61028a 0%, #5d00c7 100%);\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  left: 0;\r\n  right: 0;\r\n  top: -35px;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  z-index: 2;\r\n}\r\n\r\n.menu-search-bar .header {\r\n  font-family: Kanit;\r\n  text-align: center;\r\n  justify-content: center;\r\n  margin-top: 10px;\r\n  color: white;\r\n}\r\n\r\n.menu-search-bar .search-border {\r\n  height: 40px;\r\n  width: 300px;\r\n  position: absolute;\r\n  top: 15px;\r\n  right: 30px;\r\n  display: flex;\r\n}\r\n\r\n.menu-search-bar .search-border h3 {\r\n  font-weight: 400;\r\n  padding-right: 10px;\r\n  color: white;\r\n}\r\n\r\n.menu-search-bar input {\r\n  width: 80%;\r\n  height: 100%;\r\n  justify-items: center;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  background-image: linear-gradient(97.41deg, #000000, #000000);\r\n  border-color: white;\r\n  color: white;\r\n  border: 5px solid black;\r\n  border-radius: 5px;\r\n  font-size: 25px;\r\n  padding-left: 5px;\r\n  padding-bottom: 2.5px;\r\n  font-family: Kanit;\r\n}\r\n\r\n.table-space {\r\n  width: 250px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n  text-align: center;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n  font-family: Kanit;\r\n  font-size: 22px;\r\n  border-bottom-width: 1px;\r\n}\r\n.page-changer-container {\r\n  display: flex;\r\n\r\n  justify-content: right;\r\n  margin-right: 200px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.page-changer-container button {\r\n  width: 50px;\r\n  height: 50px;\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(97.41deg, #023e8a, #0096c7);\r\n  font-family: Kanit;\r\n  color: white;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n.page-changer-container button:hover {\r\n  background-image: linear-gradient(97.41deg, #ff792b, #a50104);\r\n}\r\n\r\n.modal-button-approve {\r\n  height: 50px;\r\n  width: 30%;\r\n\r\n  display: block;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(2, 0, 36, 1) 0%,\r\n    rgba(2, 85, 0, 1) 20%,\r\n    rgba(86, 131, 93, 1) 50%,\r\n    rgba(2, 85, 0, 1) 80%,\r\n    rgba(0, 0, 0, 1) 100%\r\n  );\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.modal-button-approve:hover {\r\n  transition-duration: 1s;\r\n\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(20, 167, 0, 1) 0%,\r\n    rgba(11, 205, 0, 1) 50%,\r\n    rgba(20, 167, 0, 1) 100%\r\n  );\r\n  color: green;\r\n}\r\n\r\n.modal-button-already-approve {\r\n  height: 50px;\r\n  width: 30%;\r\n\r\n  display: block;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(20, 167, 0, 1) 0%,\r\n    rgba(11, 205, 0, 1) 50%,\r\n    rgba(20, 167, 0, 1) 100%\r\n  );\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: green;\r\n}\r\n\r\n.modal-button-standby {\r\n  height: 50px;\r\n  width: 30%;\r\n\r\n  display: block;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(2, 0, 36, 1) 0%,\r\n    rgba(205, 113, 0, 1) 20%,\r\n    rgba(161, 99, 0, 1) 50%,\r\n    rgba(205, 113, 0, 1) 80%,\r\n    rgba(0, 0, 0, 1) 100%\r\n  );\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.modal-button-standby:hover {\r\n  transition-duration: 1s;\r\n\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(161, 99, 0, 1) 0%,\r\n    rgb(242, 210, 0) 50%,\r\n    rgba(161, 99, 0, 1) 100%\r\n  );\r\n  color: rgb(199, 130, 0);\r\n}\r\n\r\n.modal-button-already-standby {\r\n  height: 50px;\r\n  width: 30%;\r\n\r\n  display: block;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(161, 99, 0, 1) 0%,\r\n    rgb(242, 210, 0) 50%,\r\n    rgba(161, 99, 0, 1) 100%\r\n  );\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: rgb(199, 130, 0);\r\n}\r\n\r\n.modal-button-unapprove {\r\n  height: 50px;\r\n  width: 30%;\r\n\r\n  display: block;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(2, 0, 36, 1) 0%,\r\n    rgba(154, 0, 0, 1) 20%,\r\n    rgba(150, 7, 7, 1) 50%,\r\n    rgba(154, 0, 0, 1) 80%,\r\n    rgba(0, 0, 0, 1) 100%\r\n  );\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.modal-button-unapprove:hover {\r\n  transition-duration: 1s;\r\n\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(154, 0, 0, 1) 20%,\r\n    rgb(255, 0, 0) 50%,\r\n    rgba(154, 0, 0, 1) 80%\r\n  );\r\n  color: rgb(110, 0, 0);\r\n}\r\n\r\n.modal-button-already-unapprove {\r\n  height: 50px;\r\n  width: 30%;\r\n\r\n  display: block;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(154, 0, 0, 1) 20%,\r\n    rgb(255, 0, 0) 50%,\r\n    rgba(154, 0, 0, 1) 80%\r\n  );\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: rgb(110, 0, 0);\r\n}\r\n\r\n.modal-button-confirm {\r\n  height: 50px;\r\n  width: 30%;\r\n\r\n  display: block;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgb(0, 13, 97) 0%,\r\n    rgb(0, 82, 149) 50%,\r\n    rgba(0, 13, 97) 100%\r\n  );\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.modal-button-confirm:hover {\r\n  transition-duration: 1s;\r\n\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgb(0, 150, 225) 0%,\r\n    rgb(0, 238, 255) 50%,\r\n    rgba(0, 150, 225) 100%\r\n  );\r\n  color: rgb(2, 69, 176);\r\n}\r\n\r\n.modal-button-cancel {\r\n  height: 50px;\r\n  width: 30%;\r\n\r\n  display: block;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgba(154, 0, 0, 1) 0%,\r\n    rgb(129, 0, 0) 50%,\r\n    rgba(154, 0, 0, 1) 100%\r\n  );\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.modal-button-cancel:hover {\r\n  transition-duration: 1s;\r\n\r\n  background-image: linear-gradient(\r\n    90deg,\r\n    rgb(255, 153, 0) 0%,\r\n    rgb(255, 0, 0) 50%,\r\n    rgba(255, 153, 0) 100%\r\n  );\r\n  color: rgb(110, 0, 0);\r\n}\r\n\r\n@media screen and (max-width: 1400px) {\r\n  .menu-selection {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 200px;\r\n  }\r\n\r\n  .menu-selection h1 {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-left: 70px;\r\n    font-family: Kanit;\r\n    font-weight: bold;\r\n    font-size: 30px;\r\n    color: #0077b6;\r\n  }\r\n\r\n  .menu-selection .form-toggle {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n  }\r\n\r\n  .menu-selection .toggleContainer {\r\n    position: relative;\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    width: 100%;\r\n    border: 3px solid #343434;\r\n    border-radius: 10px;\r\n    background: #ffffff;\r\n    font-weight: bold;\r\n    font-size: 15px;\r\n    color: #343434;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .menu-selection .toggleContainer::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 50%;\r\n    height: 100%;\r\n    left: 0%;\r\n    border-radius: 1px;\r\n    background-image: linear-gradient(\r\n      92.88deg,\r\n      #023e8a 0%,\r\n      #0077b6 100%,\r\n      #0165a8 100%\r\n    );\r\n    transition: all 0.3s;\r\n  }\r\n  .menu-selection button {\r\n    display: block;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-right: 10px;\r\n    width: 100px;\r\n    height: 70px;\r\n    border-radius: 10px;\r\n    color: green;\r\n    background-color: white;\r\n    font-family: Kanit;\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .table-container {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n\r\n    width: 90%;\r\n    height: 575px;\r\n    background-color: rgb(255, 255, 255);\r\n    filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0));\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .menu-search-bar {\r\n    width: 90%;\r\n    height: 100px;\r\n    position: absolute;\r\n    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    left: 0;\r\n    right: 0;\r\n    top: -35px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  .menu-search-bar .header {\r\n    font-family: Kanit;\r\n    text-align: center;\r\n    justify-content: center;\r\n    margin-top: -5px;\r\n    color: white;\r\n    font-size: 25px;\r\n  }\r\n\r\n  .menu-search-bar .search-border {\r\n    height: 40px;\r\n    width: 90%;\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 50px;\r\n    display: flex;\r\n  }\r\n\r\n  .menu-search-bar .search-border h3 {\r\n    font-weight: 400;\r\n    margin-top: 35px;\r\n    color: white;\r\n  }\r\n\r\n  .menu-search-bar input {\r\n    width: 100%;\r\n    height: 100%;\r\n    justify-items: center;\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-top: 35px;\r\n    background-image: linear-gradient(97.41deg, #000000, #000000);\r\n    border-color: white;\r\n  color: white;\r\n  border: 5px solid black;\r\n  border-radius: 5px;\r\n    font-size: 25px;\r\n    padding-left: 20px;\r\n    padding-bottom: 2.5px;\r\n    font-family: Kanit;\r\n  }\r\n\r\n  .table-space {\r\n    width: 250px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    text-align: center;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    font-family: Kanit;\r\n    font-size: 20px;\r\n    border-bottom-width: 1px;\r\n  }\r\n  .page-changer-container {\r\n    display: flex;\r\n\r\n    justify-content: right;\r\n    margin-right: 20px;\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .page-changer-container button {\r\n    width: 40px;\r\n    height: 40px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    border-radius: 10px;\r\n    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);\r\n    font-family: Kanit;\r\n    color: white;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n  }\r\n}\r\n@media screen and (max-width: 1000px) {\r\n  .menu-selection {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 200px;\r\n  }\r\n\r\n  .menu-selection h1 {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-left: 70px;\r\n    font-family: Kanit;\r\n    font-weight: bold;\r\n    font-size: 30px;\r\n    color: #0077b6;\r\n  }\r\n\r\n  .menu-selection .form-toggle {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n  }\r\n\r\n  .menu-selection .toggleContainer {\r\n    position: relative;\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    width: 100%;\r\n    border: 3px solid #343434;\r\n    border-radius: 10px;\r\n    background: #ffffff;\r\n    font-weight: bold;\r\n    font-size: 15px;\r\n    color: #343434;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .menu-selection .toggleContainer::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 50%;\r\n    height: 100%;\r\n    left: 0%;\r\n    border-radius: 1px;\r\n    background-image: linear-gradient(\r\n      92.88deg,\r\n      #023e8a 0%,\r\n      #0077b6 100%,\r\n      #0165a8 100%\r\n    );\r\n    transition: all 0.3s;\r\n  }\r\n  .menu-selection button {\r\n    display: block;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-right: 10px;\r\n    width: 100px;\r\n    height: 70px;\r\n    border-radius: 10px;\r\n    color: green;\r\n    background-color: white;\r\n    font-family: Kanit;\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .table-container {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n\r\n    width: 90%;\r\n    height: 750px;\r\n    background-color: rgb(255, 255, 255);\r\n    filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0));\r\n    border-radius: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .menu-search-bar {\r\n    width: 90%;\r\n    height: 100px;\r\n    position: absolute;\r\n    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    left: 0;\r\n    right: 0;\r\n    top: -35px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  .menu-search-bar .header {\r\n    font-family: Kanit;\r\n    text-align: center;\r\n    justify-content: center;\r\n    margin-top: -5px;\r\n    color: white;\r\n    font-size: 25px;\r\n  }\r\n\r\n  .menu-search-bar .search-border {\r\n    height: 40px;\r\n    width: 90%;\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 50px;\r\n    display: flex;\r\n  }\r\n\r\n  .menu-search-bar .search-border h3 {\r\n    font-weight: 400;\r\n    margin-top: 35px;\r\n    color: white;\r\n  }\r\n\r\n  .menu-search-bar input {\r\n    width: 100%;\r\n    height: 100%;\r\n    justify-items: center;\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-top: 35px;\r\n    background-image: linear-gradient(97.41deg, #000000, #000000);\r\n    border-color: white;\r\n  color: white;\r\n  border: 5px solid black;\r\n  border-radius: 5px;\r\n    font-size: 25px;\r\n    padding-left: 20px;\r\n    padding-bottom: 2.5px;\r\n    font-family: Kanit;\r\n  }\r\n\r\n  .table-space {\r\n    width: 250px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    text-align: center;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    font-family: Kanit;\r\n    font-size: 20px;\r\n    border-bottom-width: 1px;\r\n  }\r\n  .page-changer-container {\r\n    display: flex;\r\n\r\n    justify-content: right;\r\n    margin-right: 20px;\r\n    margin-top: 175px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .page-changer-container button {\r\n    width: 40px;\r\n    height: 40px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    border-radius: 10px;\r\n    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);\r\n    font-family: Kanit;\r\n    color: white;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n  }\r\n}\r\n@media screen and (max-width: 650px) {\r\n  .menu-selection {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 200px;\r\n  }\r\n\r\n  .menu-selection h1 {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-left: 20px;\r\n    font-family: Kanit;\r\n    font-weight: bold;\r\n    font-size: 30px;\r\n    color: #0077b6;\r\n  }\r\n\r\n  .menu-selection .form-toggle {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n\r\n  .menu-selection .toggleContainer {\r\n    position: relative;\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    width: 100%;\r\n    border: 3px solid #343434;\r\n    border-radius: 10px;\r\n    background: #ffffff;\r\n    font-weight: bold;\r\n    font-size: 10px;\r\n    color: #343434;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .menu-selection .toggleContainer::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 50%;\r\n    height: 100%;\r\n    left: 0%;\r\n    border-radius: 1px;\r\n    background-image: linear-gradient(\r\n      92.88deg,\r\n      #023e8a 0%,\r\n      #0077b6 100%,\r\n      #0165a8 100%\r\n    );\r\n    transition: all 0.3s;\r\n  }\r\n  .menu-selection button {\r\n    display: block;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-right: 10px;\r\n    width: 100px;\r\n    height: 70px;\r\n    border-radius: 10px;\r\n    color: green;\r\n    background-color: white;\r\n    font-family: Kanit;\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .table-container {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n\r\n    width: 90%;\r\n    height: 575px;\r\n    background-color: rgb(255, 255, 255);\r\n    filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0));\r\n    border-radius: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .menu-search-bar {\r\n    width: 90%;\r\n    height: 100px;\r\n    position: absolute;\r\n    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    left: 0;\r\n    right: 0;\r\n    top: -35px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  .menu-search-bar .header {\r\n    font-family: Kanit;\r\n    text-align: center;\r\n    justify-content: center;\r\n    margin-top: -5px;\r\n    color: white;\r\n    font-size: 22px;\r\n  }\r\n\r\n  .menu-search-bar .search-border {\r\n    height: 40px;\r\n    width: 80%;\r\n    position: absolute;\r\n    top: 15px;\r\n    display: flex;\r\n  }\r\n\r\n  .menu-search-bar .search-border h3 {\r\n    font-weight: 400;\r\n    display: none;\r\n    color: white;\r\n  }\r\n\r\n  .menu-search-bar input {\r\n    width: 100%;\r\n    height: 100%;\r\n    justify-items: center;\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-top: 35px;\r\n    background-image: linear-gradient(97.41deg, #000000, #000000);\r\n    border-color: white;\r\n    border-color: white;\r\n    color: white;\r\n    border: 5px solid black;\r\n    border-radius: 5px;\r\n    padding-left: 5px;\r\n    padding-bottom: 2.5px;\r\n    font-family: Kanit;\r\n  }\r\n\r\n  .table-space {\r\n    width: 250px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    text-align: center;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    font-family: Kanit;\r\n    font-size: 5px;\r\n    border-bottom-width: 1px;\r\n  }\r\n  .page-changer-container {\r\n    display: flex;\r\n\r\n    justify-content: right;\r\n    margin-right: 20px;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .page-changer-container button {\r\n    width: 40px;\r\n    height: 40px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    border-radius: 10px;\r\n    background-image: linear-gradient(97.41deg, #023e8a, #0096c7);\r\n    font-family: Kanit;\r\n    color: white;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
